module.exports = __webpack_public_path__ + "static/media/nld.e53fc83f.svg";